import logoVerPerfil from '../assets/logoVerPerfil.png';

export const ViewProfileCompany = ({
    companyId,
    onSelect,
    noMargin
}) => {
    return (
        <img
            className={`${!noMargin? 'ms-3':''} cursor-pointer img-blanco-mobile`}
            src={logoVerPerfil}
            alt="View profile"
            data-bs-toggle="modal"
            data-bs-target="#modalPerfil"
            onClick={() => onSelect(companyId)}
        />
    );
};
